import { store } from '@src/state/store';
import { setPlayerMetadata } from '@src/state/slices/slice_app';

export default () =>
  (data: {
    id: number;
    address: string;
    name: string;
    img: string;
    createdAt: string;
    updatedAt: string;
  }) => {
    store.dispatch(setPlayerMetadata(data));
  };
